var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/file-msg-item.html');
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var MsgStatus = require('./../../constant/MsgStatus');
var handleMsg = {
  download: '下载',
  cancel_send: '取消',
  canceled_uploading: '已取消',
  send_fail: '失败',
  expire: '过期'
};
var handleBtnColorCls = {
  failCls: 'fail'
};

var switchText = function (ele, text) {
  ele.text(text);
};
var getChildEle = function (parentClassName, className) {
  var $content = this._element.find('.' + parentClassName);
  return $content.find('.' + className);
};
var getFileInfo = function (msg) {
  var fileInfo = {};
  var content = msg.content;
  var fileName = msg && content && content.original_file_name ? content.original_file_name : content.url && content.url.name ? content.url.name : '未知';
  var len = fileName && fileName.split('.').length ? fileName.split('.').length : 0;
  fileInfo.type = fileName && len > 0 ? fileName.split('.')[len - 1] : 'default';
  fileInfo.size = msg && content && content.size ? content.size : content.url && content.url.size ? content.url.size : '未知';
  fileInfo.name = fileName;
  return fileInfo;
};
var addFileSizeUnit = function (size) {
  if (size < 1024) {
    size = size + 'B';
  } else if (1024 <= size < 1024 * 1024) {
    size = (size / 1024).toFixed(2) + 'KB';
  } else {
    size = (size / 1024 / 1024).toFixed(2) + 'MB';
  }
  return size;
};
var getFileImgClass = function (fileType) {
  var fileImgClassName = '';
  switch (fileType.toUpperCase()) {
    case 'PDF':
      fileImgClassName = 'file-img-pdf';
      break;
    case 'PPT':
    case 'PPTX':
      fileImgClassName = 'file-img-ppt';
      break;
    case 'XLS':
    case 'XLSX':
      fileImgClassName = 'file-img-excel';
      break;
    case 'DOC':
    case 'DOCX':
      fileImgClassName = 'file-img-word';
      break;
    case 'TXT':
      fileImgClassName = 'file-img-txt';
      break;
    case 'KEY':
      fileImgClassName = 'file-img-key';
      break;
    case 'NUMBERS':
      fileImgClassName = 'file-img-numbers';
      break;
    case 'PAGES':
      fileImgClassName = 'file-img-pages';
      break;
    case 'MP4':
      fileImgClassName = 'file-img-mp4';
      break;
    case 'ZIP':
      fileImgClassName = 'file-img-zip';
      break;
    default:
      fileImgClassName = 'file-img-default';
      break;
  }
  return fileImgClassName;
};
var updateFileInfo = function () {
  var self = this;
  var msg = self._data.msg;
  var $fileImg = getChildEle.call(self, 'im-msg-content', 'im-msg-file-img');
  var $fileTitle = getChildEle.call(self, 'im-msg-content', 'im-msg-file-title');
  var $fileSize = getChildEle.call(self, 'im-msg-content', 'im-msg-file-size-num');
  // 文件图片展示
  var fileType = getFileInfo(msg).type;
  var fileImgClassName = getFileImgClass(fileType);
  $fileImg.addClass(fileImgClassName);

  // 文件标题展示
  var fileName = getFileInfo(msg).name;
  $fileTitle.text(fileName).attr("title", fileName);

  // 文件大小展示
  var fileSize = addFileSizeUnit(getFileInfo(msg).size);
  $fileSize.text(fileSize);
};

var handleUploadingPercent = function (percent) {
  var $speedContainer = getChildEle.call(this, 'im-msg-content', 'im-msg-speed');
  var $currentSpeed = $speedContainer.find('.im-msg-speed-current');
  if (!percent || percent == 0 || percent == 100) {
    $speedContainer.css('display', 'none');
    return;
  }
  $speedContainer.css('display', 'block');
  $currentSpeed.css('width', percent + 'px');
};

var FileMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;
};
FileMsgItem.prototype = Object.create(BaseMsgItem.prototype);
FileMsgItem.prototype.renderContent = function () {
  var self = this;
  var msg = self._data.msg;
  var $handleBtn = getChildEle.call(self, 'im-msg-content', 'im-msg-handle-btn');
  $handleBtn.click(function (e) {
    e.stopPropagation();
    var innerText = e.target.innerText;
    var msgitem = self._data.msg;

    // 下载文件
    if ($(e.target).hasClass('download')) {
      if (msgitem.msg_id && msgitem.status != "DOWNLOADING") {
        dispatcher.dispatch({
          type: ActionType.FILE_DOWNLOAD,
          data: msgitem
        });
      }
    } else if (innerText === handleMsg.cancel_send) {
      // 取消文件发送
      dispatcher.dispatch({
        type: ActionType.FILE_SENDE_CANCEL,
        data: msgitem
      });
    }
  });

  // 更新文件的标题、图片和大小
  this.update();
};
FileMsgItem.prototype.switchHandle = function (status) {
  var self = this;
  var $handleBtn = getChildEle.call(this, 'im-msg-content', 'im-msg-handle-btn');
  var original_text = $handleBtn.text();
  $handleBtn.removeClass('download');
  switch (status) {
    case MsgStatus.UPLOADING:
      if (original_text !== handleMsg.cancel_send) {
        switchText($handleBtn, handleMsg.cancel_send);
      }
      // 对于秒传的文件，更新进度
      var msg = self._data.msg;
      if (!msg.uploadingPercent) {
        msg.uploadingPercent = 1;
      } else {
        msg.uploadingPercent += 30;
      }
      // 更新文件的标题、图片和大小
      this.update();
      break;
    case MsgStatus.CANCEL_SENDING:
      if (original_text !== handleMsg.canceled_uploading) {
        switchText($handleBtn, handleMsg.canceled_uploading);
        handleUploadingPercent.call(self, 0);
      }
      break;
    case MsgStatus.FAIL:
      if (original_text !== handleMsg.send_fail) {
        switchText($handleBtn, handleMsg.send_fail);
        $handleBtn.addClass(handleBtnColorCls.failCls);
      }
      break;
    case MsgStatus.SUCCESS:
      if (original_text !== handleMsg.download) {
        switchText($handleBtn, '');
        $handleBtn.removeClass(handleBtnColorCls.failCls);
      }
      var msg = self._data.msg;
      msg.uploadingPercent = 100;
      this.update();
      $handleBtn.addClass('download');
      break;
    case MsgStatus.DOWNLOAD_FAIL:
      if (original_text !== handleMsg.expire) {
        switchText($handleBtn, handleMsg.expire);
        $handleBtn.addClass(handleBtnColorCls.failCls);
      }
      break;
    default:
      break;
  }
};
FileMsgItem.prototype.update = function () {
  var msg = this._data.msg;
  if (msg.uploadingPercent) {
    handleUploadingPercent && handleUploadingPercent.call(this, msg.uploadingPercent);
  }
  updateFileInfo.call(this);
};

module.exports = FileMsgItem;
